<template>
  <v-app>
    <!-- Top nav -->
    <v-app-bar app clipped-right fixed flat color="white">
      <v-toolbar-title>
        <v-img src="@/assets/img/logo-solena-black.png" width="150" />
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title v-if="test">
        <v-row class="d-flex justify-end">
          <v-col>
            <span class="primary--text text-h6">
              Bienvenido(a) {{ user.name }}
            </span>
          </v-col>
        </v-row>
      </v-toolbar-title>
      <v-spacer></v-spacer>
      <v-toolbar-title
        class="px-2"
        v-if="
          minutesToExpire > 0 &&
          minutesToExpire <= 5 &&
          daysToExpire == 0 &&
          hoursToExpire == 0
        "
      >
        <v-alert icon="mdi-alert" dense outlined type="warning" class="mb-0">
          <!-- <h5><strong>La sesión está a punto de expirar</strong></h5> -->
          <h5 v-if="minutesToExpire > 1">
            La sesión expira en: <strong>{{ minutesToExpire }} minutos</strong>
          </h5>
          <h5 v-else>
            La sesión expira en: <strong>{{ minutesToExpire }} minuto</strong>
          </h5>
        </v-alert>
      </v-toolbar-title>
      <v-toolbar-title
        class="px-2"
        v-else-if="
          minutesToExpire <= 0 && daysToExpire <= 0 && hoursToExpire <= 0
        "
      >
        <v-alert icon="mdi-alert" dense outlined type="warning" class="mb-0">
          <!-- <h5><strong>La sesión está a punto de expirar</strong></h5> -->
          <h5><strong>La sesión ha expirado</strong></h5>
        </v-alert>
      </v-toolbar-title>

      <!-- <v-list-item two-line >
            <v-list-item-avatar color="primary">
                <span class="white--text headline">{{
              user.name ? user.name.charAt(0) : ""
            }}</span>
            </v-list-item-avatar>
            <v-list-item-content>
                <v-list-item-title>{{ user.name }}</v-list-item-title>
            </v-list-item-content>
        </v-list-item> -->
      <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
    </v-app-bar>

    <!-- Left nav -->
    <v-navigation-drawer app v-model="drawer" temporary clipped right>
      <v-list nav class="ma-3">
        <!-- User info -->
        <v-list-item two-line>
          <v-list-item-avatar color="primary">
            <span class="white--text headline">{{
              user.name ? user.name.charAt(0) : ""
            }}</span>
          </v-list-item-avatar>

          <v-list-item-content>
            <v-list-item-title>{{ user.name }}</v-list-item-title>
            <v-list-item-subtitle>{{ getUserRole() }}</v-list-item-subtitle>
          </v-list-item-content>
        </v-list-item>

        <v-divider class="mb-5" />

        <v-list-item-group color="primary">
          <!-- Nav items -->
          <v-list-item
            v-for="(item, index) in items"
            :key="index"
            :to="item.to"
            active-class="highlighted"
            :class="item.path === $route.path ? 'highlighted' : ''"
          >
            <v-list-item-icon>
              <v-icon color="secondary">{{ item.icon }}</v-icon>
              <!-- <img
              :src="require('../assets/img/' + item.icon)"
              width="30"
              height="25"
            /> -->
            </v-list-item-icon>

            <v-list-item-content>
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
      </v-list>

      <!-- Logout -->
      <template v-slot:append>
        <v-btn block color="primary" @click="logOut"> Cerrar Sesión </v-btn>
      </template>
    </v-navigation-drawer>

    <!-- Content -->
    <v-main class="main_app">
      <v-container
        fluid
        :class="{
          'large-devices': $vuetify.breakpoint.xlOnly,
        }"
      >
        <router-view></router-view>
        <SessionDialog :dialog="dialog" />
      </v-container>
    </v-main>
    <v-dialog
      transition="dialog-top-transition"
      max-width="400"
      v-model="dialog_unauthorized"
      persistent
    >
      <template v-slot:default="dialog">
        <v-card>
          <v-toolbar color="warning" dark>La sesión ha expirado</v-toolbar>
          <v-card-text class="py-0">
            <div class="text-body-4 py-6">
              Puedes volver a iniciar sesión o recargar la página si es que ya
              lo hiciste.
            </div>
          </v-card-text>
          <v-card-actions class="justify-end">
            <v-btn text @click="$router.go()">Recarregar</v-btn>
            <v-btn text @click="logOut()">Volver a iniciar sesión</v-btn>
          </v-card-actions>
        </v-card>
      </template>
    </v-dialog>
    <!-- Footer -->
    <v-footer padless>
      <v-col class="text-center" cols="12">
        D.R. © Solena Ag, Inc. Av. Olímpica 3020-D Villas de San Juan 37295,
        León Gto, México.
        {{ new Date().getFullYear() }}
      </v-col>
    </v-footer>
  </v-app>
</template>

<script>
import { mapActions, mapMutations, mapState } from "vuex";
import SessionDialog from "@/components/utils/SessionDialog.vue";

export default {
  data() {
    return {
      drawer: false,
      title: "Solena Lab",
      user: {},
      items: [],
      authItems: [
        {
          icon: "mdi-logout",
          text: "Cerrar sesión",
          action: this.logOut,
        },
      ],
      dialog: false,
      actuallyDate: new Date(),
      expirationDate: new Date(localStorage.getItem("token_expiry")),
      daysToExpire: 0,
      hoursToExpire: 0,
      minutesToExpire: 10,
      test: true,
      dialog_unauthorized:false
    };
  },
  async mounted() {
    this.getUserInfo();
    await this.getExpirationTime();
    await this.setNewUserInfo();
    window.setInterval(() => {
      this.actuallyDate = new Date();
    }, 1000 * 60);
    this.setMenu();
  },
  async beforeUpdate() {
    let now = new Date();
    const token_expiry = new Date(localStorage.getItem("token_expiry"));

    if (token_expiry < now) {
      this.dialog_unauthorized = true;
    }
  },
  methods: {
    ...mapActions("session", ["logout", "getNewToken", "updateInfo"]),
    ...mapMutations("session", ["SET_AUTHENTICATED_USER"]),
    async logOut() {
      await this.logout({
        refreshToken: localStorage.getItem("refresh_token"),
        session: localStorage.getItem("session"),
      });
      this.$router.push("/login");
    },
    getUserInfo() {
      this.user = localStorage.getItem("user")
        ? JSON.parse(localStorage.getItem("user"))
        : "";
    },
    async getExpirationTime() {
      var diffMs = this.expirationDate - this.actuallyDate; // milliseconds between now & Christmas
      var diffDays = Math.floor(diffMs / 86400000); // days
      var diffHrs = Math.floor((diffMs % 86400000) / 3600000); // hours
      var diffMins = Math.round(((diffMs % 86400000) % 3600000) / 60000); // minutes

      if (
        this.daysToExpire != diffDays ||
        this.hoursToExpire != diffHrs ||
        this.minutesToExpire != diffMins
      ) {
        this.daysToExpire = diffDays;
        this.hoursToExpire = diffHrs;
        this.minutesToExpire = diffMins;
      }

      // console.log(diffDays + " days, " + diffHrs + " hours, " + diffMins + " minutes until token expires");
    },
    async setNewUserInfo() {
      if (this.user) {
        try {
          let response = await this.updateInfo({ userId: this.user._id });
          if (response) {
               if (response.user.isExpire) {
              this.dialog_unauthorized = true;
              return;
            }
            this.user = response.user;
            this.SET_AUTHENTICATED_USER(response.user);
            if (!response.user) {
              await this.logOut();
            }
          }
        } catch (error) {
          console.log(error);
          console.log("Error", this.authenticated);
          this.dialog_unauthorized = true;
        }
      }
    },
    setMenu() {
      let permissions = localStorage.getItem("permissions");
      permissions = permissions.split(",");
      if (permissions.find((permission) => permission == "prod_batch")) {
        this.items.push({
          icon: "mdi-cube-outline",
          text: "Lotes",
          to: "/batches",
        });
      }
      if (permissions.find((permission) => permission == "prod_ceparium")) {
        this.items.push({
          icon: "mdi-bacteria",
          text: "Cepario de trabajo",
          to: "/cepario-production",
        });
      }
      if (permissions.find((permission) => permission == "prod_quality")) {
        this.items.push({
          icon: "mdi-filter-cog",
          text: "Calidad",
          to: "/quality",
        });
      }
      if (permissions.find((permission) => permission == "prod_orders")) {
        this.items.push({
          icon: "mdi-transfer",
          text: "Órdenes de pedido",
          to: "/orders",
        });
      }
      if (permissions.find((permission) => permission == "prod_logistic")) {
        this.items.push({
          icon: "mdi-store-search-outline",
          text: "Logística y almacen",
          to: "/logistics",
        });
      }
    },
    getUserRole() {
      if (this.user.role == "PRODUCTION") {
        return "Producción Solena";
      } else if (this.user.role == "B2B") {
        return "RRCC";
      } else if (this.user.role == "LOGISTICS") {
        return "Logística";
      } else if (this.user.role == "QUALITY") {
        return "Calidad";
      } else if (this.user.role == "CEPARIUM") {
        return "Cepario";
      } else if (this.user.role == "ADMIN_PROD") {
        return "Administrador";
      }
    },
  },
  watch: {
    async actuallyDate() {
      await this.getExpirationTime();
    },
  },
  components: { SessionDialog },
};
</script>

<style scoped>
.main_app {
  background-color: #efefef;
}

.v-responsive {
  max-width: 97%;
}

.theme--light.v-list-item--active:hover::before,
.theme--light.v-list-item--active::before {
  opacity: 0 !important;
}
</style>
